import { StatusEnum } from "./status-enum";

export const statusColors = {
  [StatusEnum.PENDING]: "default",
  [StatusEnum.PARTIALLY_PROCESSED]: "warning",
  [StatusEnum.FULLY_PROCESSED]: "success",
};
